import { Routes } from '.generated/templates/Project.Routes.model';
import Iframe from 'components/helpers/Iframe';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

export type EducationPageProps = Routes.Fields.EducationCatalogPage;

const EducationPage = (): JSX.Element | null => {
  const { sitecoreContext } = useSitecoreContext();

  return (
    <div
      data-component="authorable/pages/educationpage"
      className="mx-auto w-full max-w-screen-2xl"
    >
      <div>
        {sitecoreContext?.route?.fields?.podcastIFrameSrc?.value && (
          <Iframe
            src={sitecoreContext?.route?.fields?.podcastIFrameSrc?.value}
            width="100%"
            height="150"
            title={sitecoreContext?.route?.fields?.podcastTitle?.value}
          />
        )}
      </div>
    </div>
  );
};
export default EducationPage;
